import { Row, Col } from 'src/componentes/grid';
import useAuth from 'src/hooks/useAuth';
import { useIntl } from 'react-intl';
import ColaboradorLookup from 'src/lookups/colaborador';
import RecursoLookup from 'src/lookups/recursolookup';
import AcaoLookup from 'src/lookups/acao';
import ItemLookup from 'src/lookups/item';
import DatePicker from 'src/componentes/date-picker';
import { capitalizeFirstLetter } from 'src/utils/string';
import { TIPO_ITENS } from 'src/utils/constants';

const Search = ({ model }) => {
  const { terms: resources } = useAuth();
  const intl = useIntl();

  return (
    <>
      <Row>
        <Col md={12}>
          <ColaboradorLookup
            clearable
            model={{
              label: capitalizeFirstLetter(resources.colaborador),
              value: model.getModel('colaborador').value,
              requestChange: model.getModel('colaborador').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <RecursoLookup
            clearable
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'recurso' })
              ),
              value: model.getModel('recurso').value,
              requestChange: model.getModel('recurso').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <ItemLookup
            clearable
            data={{ tipoId: TIPO_ITENS.PROJETO }}
            model={{
              label: capitalizeFirstLetter(resources.projeto),
              value: model.getModel('projeto').value,
              requestChange: model.getModel('projeto').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <AcaoLookup
            clearable
            model={{
              label: capitalizeFirstLetter(resources.acao),
              value: model.getModel('acao').value,
              requestChange: model.getModel('acao').requestChange,
            }}
          />
        </Col>
        <Col md={6}>
          <DatePicker
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'dataInicio' })
              ),
              value: model.getModel('dataInicio').value,
              requestChange: model.getModel('dataInicio').requestChange,
            }}
          />
        </Col>
        <Col md={6}>
          <DatePicker
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'dataTermino' })
              ),
              value: model.getModel('dataTermino').value,
              requestChange: model.getModel('dataTermino').requestChange,
            }}
          />
        </Col>
      </Row> 
    </>
  );
};

export default Search;
